import React from "react";
import { RollableTable } from "../RollableTable";

const characterMotivations = [
    "I'm determined to do what's necessary to bring order back to the earth.",
    "I'm a protector/nurturer at heart; it pains me to see good people suffering.",
    "I get a sense of belonging spending time with others. I want to learn all about the different people of the earth.",
    "I want everyone to know my name. There's glory to be had in fame or infamy.",
    "Resources are scarce; pursuit of wealth is the best motivator of all.",
    "I'm aimless: I've lost all the people in my past and I'm searching for purpose and meaning.",
    "Something horrible happened to me in the past and I won't allow it to happen again.",
    "There's so much out in the world to explore and I've got to see as much of it as I can!",
    "I'm searching for lost or ancient knowledge and I'll do almost anything to attain it.",
    "My people are counting on me to succeed on a special mission. I won't fail them.",
]
export const CharacterMotivationsTable = () => <RollableTable header="Character Flaws (1d10)" columnName="Motivation" outcomes={characterMotivations} />


const characterFlaws = [
    "I'm seeking revenge for something in my past, and I don't care what price I have to pay to exact vengeance.",
    "I get too caught up in my work to the detriment of my relationships with others. It's hard for me to relax and socialize.",
    "I often forget that I owe a great deal of my success to others; my pride won't allow me to share the glory.",
    "I don't like taking responsibility for things. I would rather shift the blame than accept the consequences of my actions.",
    "I focus too much on small problems and usually miss the bigger picture.",
    "I need instant gratification and will actively push for something to happen even when patience is the more prescient decision.",
    "I lack confidence in myself and find the threat of failure daunting.",
    "The world was destroyed long ago, I have a hard time seeing the point in trying to improve things today.",
]
export const CharacterFlawsTable = () => <RollableTable header="Character Flaws (1d8)" columnName="Flaw" outcomes={characterFlaws} />



const conflictResponses = [
    "I prefer to pursue diplomatic resolutions to avoid confict; it's better to make friends than enemies.",
    "One needs to be quick and aggressive when responding to conflict. An overwhelming show of force or intimidation will ensure that nobody decides to challenge you again.",
    "Avoiding conflict through resourceful thinking is my go-to solution. There's almost always a solution we haven't thought of yet. ",
    "I actually enjoy conflict: it allows for change and permits people to express their grievances.",
    "Conflict presents opportunity. More opportunities for me to get something I want out of the process.",
    "It's better to avoid conflict and keep those you care about safe. There's no need to get involved in problems that aren't ours yet.",
]
export const ConflictResponsesTable = () => <RollableTable header="Conflict Responses (1d6)" columnName="Conflict Response" outcomes={conflictResponses} />



const worldPerspectives = [
    "The world is a rough and tumble place fit only for those who can stand in the mud.",
    "People are ultimately good, sometimes they just need a little help.",
    "The world sucks now but we can continue working to make it better.",
    "Nobody is going to look out for you so you need to be able to look out for yourself.",
    "There's only so much time in a day so let's make the most of every second.",
    "Great deeds and leading by example gives everyone the tools they need to improve their wellbeing.",
]
export const WorldPerspectivesTable = () => <RollableTable header="World Perspectives (1d6)" columnName="World Perspectives (1d6)" outcomes={worldPerspectives} />
    


const majorLifeEvents = [
    "Some or all of my family was killed by raiders when I was younger.",
    "I grew up on a farm or ranch which endured through several droughts and smogstorms.",
    "I was fortunate enough to be born into an aristocratic family of a major province or city state and experience political life.",
    "My family traveled frequently as traders, exposing me to different ideas and cultures.",
    "I participated with a major research team at a magic academy as part of my studies there.",
    "Someone owes me a big favor after I saved their life long ago.",
    "I used to be a part of a criminal organization, but I was able to get out unscathed.",
    "I was once captured by ogres and managed to escape.",
]
export const MajorLifeExperiencesTable = () => <RollableTable header="Major Life Events (1d8)" columnName="Major Life Event" outcomes={majorLifeEvents} />